module.exports = __webpack_public_path__ + "img/FlashStation FS3410.98ccd94a.png";